/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse_FavoriteEntry_Array_ } from '../models/ControllerResponse_FavoriteEntry_Array_';
import type { FavoriteMutationBody } from '../models/FavoriteMutationBody';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FavoritesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Return the current user's favorited reports, most recently favorited first.
     * @returns ControllerResponse_FavoriteEntry_Array_ Ok
     * @throws ApiError
     */
    public getFavorites(): CancelablePromise<ControllerResponse_FavoriteEntry_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/favorites',
        });
    }
    /**
     * Favorite one or more reports for the current user. Idempotent.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public addFavorites(
        requestBody: FavoriteMutationBody,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/favorites',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Unfavorite one or more reports for the current user. No-op for ids that are
     * not favorited.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public removeFavorites(
        requestBody: FavoriteMutationBody,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/favorites',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
